import { useState, useEffect } from "react";
import styles from "./ListingHeader.module.scss";
import Search from "../../header/CustomSearch";
import Button from "../button";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import {
  AddIconSvg,
  ColumnTripleIcon,
  FilterIconSvg,
} from "../../../modules/default-svg";
import CustomPopover from "../../popover/Popover";
import CheckboxInputStateSave from "../checkboxStateSave/CheckboxStateSave";
import { useDispatch } from "react-redux";
import api from "../../../store/services/user.service";
import { generalActions } from "../../../store/actions";
import { useColumnConfig } from "../tables/ColumnConfigProvider";
import { getColumnWidth } from "../../../helpers/cookieUtils";

const EmbeddedListingHeader = (props) => {
  const {
    parentType = "",
    tableName,
    type,
    btnLable,
    searchedData,
    setIsCreate,
    rightPane,
    scopeId,
    isHeader,
    isCreatable,
    handleCreateFunc,
    isSearchDisable,
    setTaskColumns,
    triggerSearch,
  } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const dispatch = useDispatch();
  const { getColumnConfigs, onRefreshColumnConfig } = useColumnConfig();
  const [columnConfig, setColumnConfig] = useState([]);
  const [tempColumnConfig, setTempColumnConfig] = useState([]);

  useEffect(() => {
    if (tableName) {
      const configs = getColumnConfigs(tableName)?.sort(
        (a, b) => a.order - b.order
      );
      setColumnConfig(configs);
      setTempColumnConfig(configs);
    }
  }, []);

  const handleLabelChange = (columnId, newLabel) => {
    const customColumns = tempColumnConfig.map((col) =>
      col.columnId === columnId ? { ...col, customName: newLabel.trim() } : col
    );
    setTempColumnConfig(customColumns);
  };

  const handleColumnsChange = (id) => {
    const newColumnConfig = tempColumnConfig.map((col) => {
      if (col.label === id) {
        return {
          ...col,
          isVisible: !col.isVisible,
        };
      }
      return col;
    });
    const updatedColumns = newColumnConfig.map((col) => ({
      name: col.label,
      customName: "",
      order: col.order,
      isVisible: col.isVisible,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumns,
    };

    api
      .putUserLayoutRequest(payload)
      .then(() => {})
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column status",
            type: "error",
          })
        );
      })
      .finally(() => {
        onRefreshColumnConfig();
        setColumnConfig(newColumnConfig);
        setTempColumnConfig(newColumnConfig);
        setTaskColumns(
          newColumnConfig.map((col) => ({
            accessorKey: col.accessorKey,
            header: col.label,
            size: getColumnWidth("Scope-Tasks", col.accessorKey),
            isVisible: col.isVisible,
            isSortable: col.isSortable,
            columnType: col.columnType,
            columnId: col.columnId,
            order: col.order,
            label: col.label,
          }))
        );
      });
  };

  const handleSaveChanges = () => {
    const updatedColumns = tempColumnConfig.map((col) => ({
      name: col.label,
      customName: col.customName ?? "",
      order: col.order,
      isVisible: col.isVisible,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumns,
    };

    api
      .putUserLayoutRequest(payload)
      .then(() => {})
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column name",
            type: "error",
          })
        );
      })
      .finally(() => {
        onRefreshColumnConfig();
        setColumnConfig(tempColumnConfig);
        setTempColumnConfig(tempColumnConfig);
        setTaskColumns(
          tempColumnConfig.map((col) => ({
            accessorKey: col.accessorKey,
            header: col.customName !== "" ? col.customName : col.label,
            size: getColumnWidth("Scope-Tasks", col.accessorKey),
            isVisible: col.isVisible,
            isSortable: col.isSortable,
            columnType: col.columnType,
            columnId: col.columnId,
            order: col.order,
            label: col.label,
          }))
        );
      });
  };

  const handleResetChanges = () => {
    const payload = {
      Name: tableName,
      Columns: null,
    };

    api
      .putUserLayoutRequest(payload)
      .then(() => {})
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Error on ressting columns",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsPopoverOpen(false);
        const newColumnConfig = tempColumnConfig
          .map((col) => ({
            ...col,
            isVisible: true,
          }))
          .sort((a, b) => a.order - b.order);
        onRefreshColumnConfig();
        setColumnConfig(newColumnConfig);
        setTempColumnConfig(newColumnConfig);
        setTaskColumns(
          newColumnConfig.map((col) => ({
            accessorKey: col.accessorKey,
            header: col.label,
            size: 160,
            isVisible: col.isVisible,
            isSortable: col.isSortable,
            columnType: col.columnType,
            columnId: col.columnId,
            order: col.order,
            label: col.label,
          }))
        );
      });
  };

  const handleCreate = () => setIsCreate && setIsCreate(true);

  return (
    <div className={styles.listingHeader}>
      <div className={styles.searchFilterWrapper}>
        <Search
          parentType={parentType}
          type="Tasks"
          searchResult={searchedData}
          scopeId={scopeId}
          isDisabled={!isSearchDisable}
          triggerSearch={triggerSearch}
        />
        <div className={`${styles.filterWrapper} text-sm-600 ms-2`}>
          <span className="me-1">
            <FilterIconSvg />
          </span>
          Filter
        </div>
      </div>
      {rightPane && (
        <div className="d-flex align-items-center">
          {/* Select Columns */}
          <CustomPopover
            icon={
              <Button
                btnClass="d_btn d_btn_dualIconXsm"
                rightIcon={
                  <span className="columnBadge ms-1">
                    {columnConfig?.length &&
                      columnConfig.filter((col) => col.isVisible).length}
                  </span>
                }
                icon={<ColumnTripleIcon />}
                label="Select Columns"
              />
            }
            status={isPopoverOpen}
            onOpenChange={(e, data) => setIsPopoverOpen(data.open)}
          >
            <div className="d-flex flex-col gap-1 relative overflow-auto max-h-[272px]">
              {tempColumnConfig?.length &&
                tempColumnConfig.map((item) => (
                  <CheckboxInputStateSave
                    columnId={item.columnId}
                    label={item.label}
                    type={type}
                    parentType={parentType}
                    isColumnConfig={true}
                    customName={item.customName}
                    checked={item.isVisible}
                    onChange={() => handleColumnsChange(item.label)}
                    onLabelChange={(newLabel) =>
                      handleLabelChange(item.columnId, newLabel)
                    }
                    onSaveChanges={handleSaveChanges}
                  />
                ))}
              <div
                className="d-flex justify-content-end mt-2 sticky bottom-0 pt-[12px] bg-white"
                style={{ borderTop: "1px solid #e5e5e5" }}
              >
                <Button
                  label="Reset Columns"
                  btnClass="d_btn d_btn_primary me-10"
                  clickHandler={handleResetChanges}
                />
                <Button
                  label="Cancel"
                  btnClass="d_btn d_btn_smallWhite"
                  btnType="secondary"
                  clickHandler={() => setIsPopoverOpen(false)}
                />
              </div>
            </div>
          </CustomPopover>

          {/* Create Button */}
          {isHeader && (
            <Button
              btnClass="d_btn d_btn_primary ms-12"
              icon={<AddIconSvg />}
              label={btnLable}
              clickHandler={handleCreate}
            />
          )}

          {/* Add Row Button */}
          {/* {isCreatable && ( */}
          {false && ( // Enforcing to false untill we revisit teh inline creation/update
            <Button
              btnClass="d_btn d_btn_primary ms-12"
              icon={<AddIconSvg />}
              label="Add Row"
              clickHandler={handleCreateFunc}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default EmbeddedListingHeader;
